import React, { useState, useEffect, useContext } from "react";
import { Modal, Button, Input, Select, Radio } from "antd";
import './CheckoutModal.css'
import listApi from "../../services/api";
const MyQR = require('../../assets/qr_banking.jpg')
const { Option } = Select;


const CheckoutModal = ({ visible, onClose,selectedVoucher, cart, price, clearCart, userData  }) => {
    // const [provinces, setProvinces] = useState([]); // Danh sách tỉnh/thành phố
    // const [districts, setDistricts] = useState([]); // Danh sách quận/huyện
    // const [selectedProvince, setSelectedProvince] = useState(null); // ID của tỉnh/thành phố đã chọn


    const [formData, setFormData] = useState({
        fullName: "",
        phone: "",
        message: "",
        deliveryMethod: "home",
    });
    

    useEffect(() => {
        console.log("Check data",userData)
    }, [userData])
    

    // Lấy danh sách tỉnh/thành phố khi component mount
    // useEffect(() => {
    //     const fetchProvinces = async () => {
    //         fetch(`https://vn-public-apis.fpo.vn/provinces/getAll?limit=-1`,
    //             {
    //                 method: 'GET',
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                 },
    //             }).then((response) => response.json()
    //             ).then((response) => {
    //                 console.log("check: ", response.data);
    //                 if (response.message == 'Get all items successful') {
    //                     setProvinces(response.data.data)
    //                 } else {
    //                     console.log("Lỗi", response.message)
    //                 }
    //             }).catch((error) => {
    //                 console.log(error)
    //             });
    //     }
    //     fetchProvinces();
    // }, []);

    // Xử lý chọn tỉnh/thành phố
    // const handleProvinceChange = (value, option) => {
    //     console.log("Thành phố đã chọn chọn:", option);
    //     setSelectedProvince(option.key);
    //     setFormData((prev) => ({ ...prev, city: value, district: "" }));
    //     setDistricts([]);
    // };


    // Lấy danh sách quận/huyện khi tỉnh/thành phố thay đổi
    // useEffect(() => {
    //     if (!selectedProvince) return;
    //     const fetchDistricts = async (id) => {
    //         fetch(`https://vn-public-apis.fpo.vn/districts/getByProvince?provinceCode=${id}&limit=-1`,
    //             {
    //                 method: 'GET',
    //                 headers: {
    //                     'Content-Type': 'application/json',
    //                 },
    //             }).then((response) => response.json()
    //             ).then((response) => {

    //                 console.log("check: ", response.data.data);
    //                 setDistricts(response.data.data)

    //             }).catch((error) => {
    //                 console.log(error)
    //             });
    //     }

    //     fetchDistricts(selectedProvince);
    // }, [selectedProvince]);

    // Xử lý thay đổi form
    
    const handleChange = (field, value) => {
        setFormData((prev) => ({ ...prev, [field]: value }));
    };

    const handleConfirm = async () => {
        console.log("Bắt đầu nhận đơn");
        const list_item = cart.map(item => ({
            product_id: item.ID,
            number_item: item.quantity
        }));

        const body = {
            session_id: userData?.session_id,
            voucher_id: selectedVoucher?.ID || "",
            name: formData.fullName,
            tel: formData.phone,
            list_item: list_item,
        };

        console.log("Check body", body);

        try {
            const response = await fetch(listApi.newOrder, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const data = await response.json();
            console.log("Xác nhận đơn hàng:", data);
            
            if (data.code === 200) {
                clearCart()
                alert("Đơn hàng đã được tạo thành công!");
            } else {
                alert("Có lỗi xảy ra khi tạo đơn hàng. Vui lòng thử lại.");
            }
        } catch (error) {
            console.error("Lỗi khi gọi API:", error);
            alert("Có lỗi xảy ra khi gọi API. Vui lòng thử lại.");
        }
        onClose();
    };


    return (
        <Modal
            title="Xác Nhận Thanh Toán"
            open={visible}
            onCancel={onClose}
            footer={[
                <Button key="cancel" onClick={onClose}>
                    Hủy
                </Button>,
                <Button key="confirm" type="primary" onClick={handleConfirm}>
                    Xác Nhận
                </Button>,
            ]}
        >
            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                <label>Họ tên:</label>
                <Input
                    placeholder="Nhập tên khách hàng"
                    value={formData.fullName}
                    onChange={(e) => handleChange("fullName", e.target.value)}
                />
                <label>Điện thoại:</label>
                <Input
                    placeholder="Nhập điện thoại khách hàng"
                    value={formData.phone}
                    onChange={(e) => handleChange("phone", e.target.value)}
                />
                {/* <label>Phương thức nhận hàng:</label>
                <Radio.Group
                    value={formData.deliveryMethod}
                    onChange={(e) => handleChange("deliveryMethod", e.target.value)}
                >
                    <Radio value="home">Giao tận nhà</Radio>
                    <Radio value="store">Nhận tại cửa hàng</Radio>
                </Radio.Group> */}
            </div>
            <div className="bank-info">
                <h4>🔹 Thông Tin Chuyển Khoản</h4>
                <div style={{display:'flex', marginTop:'1rem'}}>
                    <div>
                        <p><strong>Ngân hàng:</strong> Techcombank</p>
                        <p><strong>Chủ tài khoản:</strong> KIEU TRUNG DUC</p>
                        <p><strong>Số tài khoản:</strong> <span className="account-number">1110333333</span></p>
                        <p>(Vui lòng nhập đúng số tài khoản và nội dung khi chuyển khoản)</p>
                    </div>
                    <div className="qr-code">
                        <img src={MyQR} alt="QR Code Thanh Toán" />
                    </div>
                </div>
            </div>
        </Modal>
    );
};

export default CheckoutModal;
